import { render, staticRenderFns } from "./certimanage.vue?vue&type=template&id=3071f82c&scoped=true&"
import script from "./certimanage.vue?vue&type=script&lang=js&"
export * from "./certimanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071f82c",
  null
  
)

export default component.exports